module.exports = __webpack_public_path__ + "static/media/stockprofiticon.d338a3df.svg";